import { SecurityWeight, StrategyWeight } from '@/cip/_openapi/portfolio-optimizer';

import { StrategyElementFormValue } from './model-form-schema';

interface MixedAssetAllocationWeights {
    strategyWeights: StrategyWeight[];
    securityWeights: SecurityWeight[];
}

export const computeMixedAssetAllocationWeights = (
    elements: StrategyElementFormValue[],
): MixedAssetAllocationWeights => {
    const strategyWeights: StrategyWeight[] = [];
    const securityWeights = new Map<string, number>();

    elements.forEach((element) => {
        const elementWeight = (parseFloat(element.weight) || 0) / 100;
        if (elementWeight <= 0) return;

        if (element.mode === 'existing') {
            if (element.existingStrategyGUID) {
                strategyWeights.push({ strategyGuid: element.existingStrategyGUID, weight: elementWeight });
            }
        } else {
            (element.newStrategyAssetAllocations || []).forEach((asset) => {
                const assetWeight = (parseFloat(asset.weight) || 0) / 100;
                const contribution = elementWeight * assetWeight;
                if (contribution > 0)
                    securityWeights.set(asset.securityId, (securityWeights.get(asset.securityId) || 0) + contribution);
            });
        }
    });

    return {
        strategyWeights,
        securityWeights: Array.from(securityWeights.entries()).map(([sId, weight]) => ({ sId, weight })),
    };
};
